import type {NavigationGuard} from 'vue-router';
import {useServiceAccount} from '@/composables/useServiceAccount/useServiceAccount';

export const orderRulesGuard: NavigationGuard = () => {
  const {isOrderRulesAccessible} = useServiceAccount();

  if (isOrderRulesAccessible.value) {
    return true;
  }

  return {name: 'dashboard'};
};
